<section class="template-editor-container" aria-labelledby="template-editor-title">
    <header class="editor-heading">
        <div>
            <span>Ontologie-Editor</span>
            <h3 id="template-editor-title">Zertifizierungsvorlage</h3>
            <p>Eigenschaften strukturieren, gruppieren und mit Validierungsgrenzen versehen.</p>
        </div>
    </header>

    <div class="editor-tree" [class.drop-inside-mode]="dragState.hasInsideTarget" cdkDropListGroup>
        <div class="root-node" [class.drop-inside-active]="dragState.isRootTarget(nodes)"
            (pointerenter)="onRootTargetEnter()" (pointerleave)="onRootTargetExit()">
            <span class="root-icon"><mat-icon>account_tree</mat-icon></span>
            <div class="root-copy">
                <span>Root Node</span>
                <strong>Zertifizierungsvorlage</strong>
            </div>
            <button mat-flat-button color="primary" class="add-property-button" type="button" (click)="addNode()">
                <mat-icon>add</mat-icon>
                Neues Attribut hinzufügen
            </button>
        </div>

        <div class="root-branch">
            <div cdkDropList [cdkDropListData]="nodes" (cdkDropListDropped)="drop($event)"
                class="node-list root-node-list" aria-label="Eigenschaften der Zertifizierungsvorlage">
                @for (node of nodes; track node.id || $index) {
                <app-template-node-editor [node]="node" [parentNodes]="nodes" (nodeChange)="onNodesChange()" cdkDrag
                    [cdkDragData]="node" (cdkDragStarted)="dragState.start(node)">
                </app-template-node-editor>
                }

                @if (!nodes.length) {
                <div class="empty-root">
                    <mat-icon>subdirectory_arrow_right</mat-icon>
                    <span>Noch keine Properties. Fügen Sie die erste Property hinzu oder legen Sie sie hier ab.</span>
                </div>
                }
            </div>
        </div>
    </div>
</section>
